module.exports = __webpack_public_path__ + "static/media/cq_inoltra_documento.2d1214a3.svg";